var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{staticClass:"skeleton-row"},[_c('td',{staticClass:"skeleton-wrapper",attrs:{"colspan":_vm.colspan}},_vm._l((1),function(i){return _c('div',{key:("skeleton-line-" + i),staticClass:"skeleton-line"})}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }